import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { filter, isEmpty } from 'lodash';

import { SYMBOLOGY_TYPES, PROP_DATA_TYPE } from '../../../api/Styles/Styles';

const PropertiesOptions = ({ geojsonProperties }) => {
  if (!isEmpty(geojsonProperties)) {
    return geojsonProperties.map(geojsonProperty => (
      <option key={geojsonProperty.name} value={geojsonProperty.name}>
        {geojsonProperty.name}
      </option>
    ));
  }
  return null;
};
PropertiesOptions.propTypes = {
  geojsonProperties: PropTypes.array.isRequired
};

const GeoJSONAttributesField = ({
  changeSelectedProperty,
  propName,
  geojsonProperties,
  symbologyType
}) => {
  let filterNumberProps = geojsonProperties;
  let noNumericProperties = false;
  if (symbologyType === SYMBOLOGY_TYPES.NUMERIC) {
    filterNumberProps = filter(geojsonProperties, ['dataType', PROP_DATA_TYPE.NUMBER]);
    noNumericProperties = isEmpty(filterNumberProps);
  }
  return (
    <Form.Group>
      <Form.Label>Attributes</Form.Label>
      <Form.Control
        as="select"
        name="propName"
        defaultValue={propName}
        onChange={changeSelectedProperty}
      >
        <option key="" value="">
          -
        </option>
        <PropertiesOptions geojsonProperties={filterNumberProps} symbologyType={symbologyType} />
      </Form.Control>
      {noNumericProperties && <Form.Text className="text-danger">No numeric data</Form.Text>}
    </Form.Group>
  );
};

GeoJSONAttributesField.propTypes = {
  propName: PropTypes.string.isRequired,
  changeSelectedProperty: PropTypes.func.isRequired,
  symbologyType: PropTypes.string.isRequired,
  geojsonProperties: PropTypes.array.isRequired
};

export default GeoJSONAttributesField;
